import React, { useContext, useState, useEffect, useRef } from "react";
import { useSwipeable } from 'react-swipeable';
import { Row, Col, Dropdown, Button, Form, OverlayTrigger, Tooltip, Overlay } from "react-bootstrap";
import { useCrackersFilters } from "../hooks/useCrackersFilters";
import '../App.css';
import BreadcrumbMenu from "./BreadcrumbMenu";
import BuildPagination from "./BuildPagination";
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { CrackersContext } from "../CrackersContext";
import { raiseGetRequest, addCrackersIntoCart, getCarts, getCartItems, getCracker } from "../AxiosAPI";
import { isSmScreen, isXSmScreen, numericInputOnly, queryString, costOfCracker, isSmallTouchScreen } from "../CrackersUtil";
import PageLoader from "./PageLoader";

import incr from '../images/cl_incr.png';
import decr from '../images/cl_decr.png';
import updown from '../images/up_down.png';
import agntNF from '../images/agent_n_f.jpg'
import { LoadingBorder } from "./LoadingSpinner";
import { data } from "jquery";
import DescriptionPopUp from "./DescriptionPopUp";
import Joyride from "react-joyride";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Crackers({selectedCart, cartImageRef}) {
  const queryParams = useQuery();
  const { 
            serviceCommonData, agents, crackersData, setCrackersData, agentCode, 
            setAgentCode, crackersFilter, setCrackersFilter, crackersCategory, 
            setCrackersCategory, setLandingPage, setShowErrorToastStatus, setToastBody, activePage, setActivePage, userInfo, browserCart, setBrowserCart, setIsZeroCasePage } = useContext(CrackersContext);
  const [filteredCrackers, setFilteredCrackers] = useState([]);
  const [crackerLoading, setCrackerLoading] = useState(false);
  const [crackerError, setCrackerError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [selectedFilterId, setSelectedFilterId] = useState(-1);
  const [cartItems, setCartItems] = useState({});
  const [selectedAgentName, setSelectedAgentName] = useState();
  const [agentNotFound, setAgentNotFound] = useState(false);
  const [cartValuation, setCartValuation] = useState({"number_of_items" : 0, "total_quantity" : 0, "total_cost" : 0});

  const { filters, filterLoading, filterError } = useCrackersFilters();
  const [windowSize, setWindowSize] = useState({width: window.innerWidth, height: window.innerHeight});

  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isXSmallScreen, setIsXSmallScreen] = useState(false);
  
  const navigate = useNavigate();

  const clMenu = {
                    position : "sticky", 
                    top :  '10.5%',
                    background : "white",
                    zIndex : 1000
                  };

  var agentId = queryParams.get('agent_id');
  var rType = null;
  var rPage = queryParams.get("fPage");
  if(rPage && rPage !== undefined) {
    rType = queryParams.get("rType");
  }
  
  var clType = queryParams.get("clType");
  

  if(selectedCart === undefined || selectedCart === null || selectedCart.length === 0) {
    selectedCart = "Default";
  }

  const cartImageChecker = async (cartName) => {
    const cartsData = await getCarts(userInfo, setShowErrorToastStatus, setToastBody, browserCart);
    if (cartsData) {
      // const cartList = cartsData.map((cart) => { return cart.name });
      const cartsInfo = {};
      for (let i = 0; i < cartsData.length; i++) {
        let cartInfo = {};
        cartsInfo[cartsData[i].name] = cartsData[i];
      }
      if (cartsInfo && cartsInfo[cartName]) {
        if (cartsInfo[cartName]['number_of_items'] > 0) {
          cartImageRef.current.src = "/client/images/f_cart.png";
        } else {
          if(cartImageRef.current) {
            cartImageRef.current.src = "/client/images/cart.png";
          }
        }
      } else {
        if(cartImageRef.current) {
          cartImageRef.current.src = "/client/images/cart.png";
        }
        
      }
    }
  }

  function getAgentName(agentId) {
    for(let i=0; i<agents.length; i++) {
      if(agents[i].id == agentId) {
        return agents[i].name;
      }
    }
    return "--Select Dealer--";
  }

  const handlePageChange = (pageNumber) => {
    if (pageNumber !== activePage) {
      navigate(window.location.pathname, { replace: true });
      setActivePage(pageNumber);
    }
  };

  useEffect(() => {
    if(isSmallTouchScreen(window.innerWidth)) {
      setIsZeroCasePage(true);
    } else {
      setIsZeroCasePage(false);
    }
    
    setCrackerLoading(true);
    // setCrackersData(null);
    setFilteredCrackers(null);
    if (agentId && agentId.trim() !=='') {
      agentId = Number(agentId);
      setAgentCode(agentId);
    } else if (!agentCode) {
      agentId = agents[0].id;
      setAgentCode(agentId);
    }

    const getCartItemsResp = async (crackersData) => {
      if(agentCode) {
        const cartItemsResp = await getCartItems(userInfo, crackersData, selectedCart, agentCode, setShowErrorToastStatus, setToastBody, browserCart);
        const cartValue = {};
        if (cartItemsResp && cartItemsResp.length > 0) {
          cartValue["number_of_items"] = 0;
          cartValue["total_quantity"] = 0;
          cartValue["total_cost"] = 0;
          var cartItemsObj = {};
          for (let i = 0; i < cartItemsResp.length; i++) {
            if(cartItemsResp[i].quantity > 0) {
              cartItemsObj[cartItemsResp[i].cracker_id] = cartItemsResp[i];
              cartValue["number_of_items"] = cartValue["number_of_items"] + 1;
              cartValue["total_quantity"] += cartItemsResp[i].quantity;
              cartValue["total_cost"] += cartItemsResp[i].total_cost;
            }
          }
          setCartItems(cartItemsObj);
          if(cartImageRef.current) {
            cartImageRef.current.src = "/client/images/f_cart.png";
          }
        } else {
          cartValue["number_of_items"] = 0;
          cartValue["total_quantity"] = 0;
          cartValue["total_cost"] = 0;
          setCartItems({});
          if(cartImageRef.current) {
            cartImageRef.current.src = "/client/images/cart.png";
          }
        }
        setCartValuation(cartValue);
        return cartItemsResp;
      }
    }

    const fetchCrackers = async (selectedAgent) => {
      setAgentNotFound(false);
      try {
        setCrackersData(null);
        if(selectedAgent === null || selectedAgent === undefined) {
          if(serviceCommonData) {
            selectedAgent = serviceCommonData.default_agent_id;
          }
        }

        if(selectedAgent === null || selectedAgent === undefined) {
          selectedAgent = 1000;
        }
        console.log(rPage);
        var uri = null;
        if(rPage && rPage === "hp") {
          uri = `/crackers?agent_id=${selectedAgent}&rPage=hp`;
        } else {
          uri = `/crackers?agent_id=${selectedAgent}`;
        }
        const data = await raiseGetRequest(uri, null, setShowErrorToastStatus, setToastBody);
        if(data) {
          if(data.error_code) {
            switch(data.error_code) {
              case "40004":
                setAgentNotFound(true);
                setFilteredCrackers(null);
              break;
            }
            return {};
          } else {
            return data;
          }
        } else {
          return {};
        }
      } catch (error) {
        return null;
      }
    };

    const getPassedFilterId = () => {
      const passedFilter = queryParams.get('filter');
      if (passedFilter) {
        const foundFilter = filters.find(filter => filter.filter === passedFilter);
        if (foundFilter) {
          return foundFilter.id;
        }
      }
      return 1000000000000;
    };

    const checkPassedFilter = () => {
      const passedFilter = queryParams.get('filter');
      if (passedFilter) {
        filters.forEach((filter) => {
          if (filter.filter === passedFilter) {
            setSelectedFilter(passedFilter);
            setSelectedFilterId(filter.id);
          }
        });
      }
    };

    const fetchData= async() => {
      var selectedAgent = 1000;
      // if(agentCode && agentCode !== 'null') {
      //   selectedAgent = agentCode;
      // } else if(agentId) {
      //   selectedAgent = agentId;
      // } else if(serviceCommonData.hasOwnProperty("default_agent_id")) {
      //   selectedAgent = serviceCommonData.hasOwnProperty("default_agent_id");
      // } else {
      //   if(agents !== null && agents !== undefined) {
      //     selectedAgent = agents[0].id;  
      //   } else {
      //     selectedAgent = 1000;
      //   }
        
      // }

      setSelectedAgentName(getAgentName(selectedAgent));
      if (selectedAgent) {
        if (crackersData && crackersData.agent_code) {
          if (crackersData.agent_code === selectedAgent) {
            checkPassedFilter();
            processCrackersOptions(crackersData, getPassedFilterId());
            setCrackerLoading(false);
            if(selectedCart && selectedCart.trim() !=='') {
              getCartItemsResp(crackersData);
              cartImageChecker(selectedCart);
            }
          } else {
            const data = await fetchCrackers(selectedAgent);
            if(data) {
              setCrackersData(data);
            } else {
              setCrackersData({});
            }
            
            checkPassedFilter();
            processCrackersOptions(data, getPassedFilterId());
            setCrackerLoading(false);
            if(selectedCart && selectedCart.trim() !=='') {
              getCartItemsResp(data);
              cartImageChecker(selectedCart);
            }
          }
        } else {
          const data = await fetchCrackers(selectedAgent);
          if(data) {
            setCrackersData(data);
          } else {
            setCrackersData({});
          }
          
          checkPassedFilter();
          processCrackersOptions(data, getPassedFilterId());
          setCrackerLoading(false);
          if(selectedCart && selectedCart.trim() !=='') {
            getCartItemsResp(data);
            cartImageChecker(selectedCart);
          }
        }
      } else {
        setCrackersData({});
        setCrackerLoading(false);
      }
    }
    fetchData();

    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
      setIsSmallScreen(isSmScreen(window.innerWidth));
      setIsXSmallScreen(isXSmScreen(window.innerWidth));
    };
    
    function scrollWhenReady() {
      var clContainer = null;
      if(rType && rType !== undefined) {
        clContainer = document.querySelector("#cl_" + rType.replace(/ /g, "_"));
      } else if(clType && clType !== undefined) { 
        clContainer = document.querySelector("#cl_" + clType.replace(/ /g, "_"));
      } 

      if(clContainer === null || clContainer === undefined) {
        clContainer = document.querySelector(".cl_container");
      }
      
      if (clContainer) {
        clContainer.scrollIntoView({ behavior: "smooth" });
      } else {
        setTimeout(scrollWhenReady, 50);
      }
    }
    scrollWhenReady();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, [agentCode, selectedCart, activePage]);

  const processCrackersOptions = (data, filterId) => {
    var showPage = -1;
    if (data && Object.keys(data).length > 0) {
      var filteredCrackers = {};
      if (filterId !==-1) {
        var resultPage = 1, categoryCount = 0, crackersPerPage = 0;
        for (let i = 1; i <= data["number_of_page"]; i++) {
          // filteredCrackers[i] = data[i].map(category => ({
          //   ...category,
          //   crackers: category.crackers.filter(cracker => cracker.filter_id <= filterId)
          // }));
          const types = data[i];
          const updatedTypes = types.map(category => {
            const updatedType = {
              ...category
            };
            updatedType.crackers = category.crackers.filter(cracker => {
              return cracker.filter_id <= filterId;
            });
            return updatedType;
          });
          if(updatedTypes.length > 0) {
            for(var j=0; j<updatedTypes.length; j++) {
              var crackerType = updatedTypes[j];
              if(rType && rType !== undefined && crackerType.type === rType) {
                showPage = resultPage;
              }
              
              if(crackerType['crackers'].length > 0) {
                crackersPerPage += crackerType['crackers'].length;
                if(!filteredCrackers.hasOwnProperty(resultPage)) {
                  filteredCrackers[resultPage] = [];
                }
                filteredCrackers[resultPage].push(crackerType);
                categoryCount++;
                if(categoryCount === 5 || crackersPerPage > 20) {
                  resultPage++;
                  crackersPerPage = 0;
                  categoryCount = 0;
                }
              }
            }
          }
        }
        if(filteredCrackers[resultPage]) {
          filteredCrackers["number_of_page"] = resultPage;
        } else {
          filteredCrackers["number_of_page"] = --resultPage;
        }

        if(showPage !== -1) {
          setActivePage(showPage);
        } else if(Number(activePage) > resultPage) {
          setActivePage(1);
        } else {
          setActivePage(Number(activePage));
        }
        
      } else {
        filteredCrackers = data;
        filteredCrackers["number_of_page"] = data["number_of_page"];
      }
      
      setFilteredCrackers(filteredCrackers);
    } else {
      setFilteredCrackers(null);
    }
  };

  const agentSelect = (eventKey, event) => {
    setCrackersData({});
    setActivePage(1);
    setAgentCode(Number(eventKey));
    navigate(`/web/crackers?filter=${selectedFilter}&agent_id=${eventKey}`)
  }

  const filterSelect = (eventKey, event) => {
    setActivePage(1);
    setSelectedFilter(event.target.textContent);
    setSelectedFilterId(Number(eventKey));
    processCrackersOptions(crackersData, Number(eventKey));
  };

  const categorySelect = (eventKey, event) => {
    setSelectedCategory(event.target.textContent);
  };

  return (
    <div>
      {/* <Row style={clMenu}>
        <Col xs={1} sm={1} md={1}></Col>
        <Col xs={11} sm={11} md={3}>
          <BreadcrumbMenu items={[{ caption: "Home", link: "/web" }, { caption: "Crackers", activePage: true }]} />
        </Col>
      </Row> */}
      {
        isSmallTouchScreen(window.innerWidth) ? (
          <div>
            <div className="mob-filter">
              <Row>
                <Col xs={6} className="d-flex justify-content-end step1">
                  <Dropdown id='cl_dd_filter' className="cl_dd" onSelect={filterSelect}>
                    <Dropdown.Toggle variant="warning">
                    Explore by Age: {selectedFilter}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filters.map((filter) => (
                        <Dropdown.Item key={filter.id} eventKey={filter.id}>{filter.filter}</Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>

                <Col xs={6} className="d-flex justify-content-start step2">
                  <Dropdown className="cl_dd" onSelect={categorySelect}>
                    <Dropdown.Toggle variant="warning">
                      Category: {selectedCategory}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {crackersCategory.map((category) => (
                        <Dropdown.Item key={category.category}>{category.category}</Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
              </Row>
            </div>
            {/* <MobileCrackersTile key={selectedFilter + selectedCategory} 
                              filteredCrackers={filteredCrackers}
                              crackersList={crackersData}
                              selectedCategory={selectedCategory}
                              selectedCart={selectedCart}
                              cartItems={cartItems}
                              cartImageChecker={cartImageChecker}
                              cartImageRef={cartImageRef}
                              setLandingPage={setLandingPage}
                              serviceCommonData={serviceCommonData}
                              setCartItems={setCartItems}
                              setCartValuation={setCartValuation}
                              rType={rType}
                              /> */}
                  {filteredCrackers && Object.keys(filteredCrackers).length > 0 ? (
                    <BuildCrackersList
                      crackersList = {crackersData}
                      filteredCrackers={filteredCrackers}
                      activePage={activePage}
                      selectedCategory={selectedCategory}
                      selectedFilter={selectedFilter}
                      selectedCart={selectedCart}
                      cartItems={cartItems}
                      cartImageChecker={cartImageChecker}
                      cartImageRef={cartImageRef}
                      agentCode={agentCode}
                      setLandingPage={setLandingPage}
                      serviceCommonData={serviceCommonData}
                      setCartItems={setCartItems}
                      setCartValuation={setCartValuation}
                      handlePageChange={handlePageChange}
                      agentNotFound={agentNotFound}
                    />
                ) : (
                  agentNotFound ? (<DealerNotFound />) : (<CrackersNotFound />)
                )}
          </div>
          
        ) : (
            <div>
              <Row style={clMenu}>
                <Col xs={1} sm={1} md={1}></Col>
                <Col xs={11} sm={11} md={3} className="d-flex align-items-center">
                  <BreadcrumbMenu items={[{ caption: "Home", link: "/web" }, { caption: "Crackers", activePage: true }]} />
                </Col>
                <Col xs={11} sm={11}  md={7} className="d-flex justify-content-end cl_controller cl_dd_col">
                    <div style={{display : "flex", flexDirection : "row", marginRight : "4%"}} className="d-flex align-items-center">
                      {/* <Dropdown id='cl_dd_agents' className="cl_dd" onSelect={agentSelect}>
                        <Dropdown.Toggle variant="primary">
                          {selectedAgentName}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {agents.map((agent) => (
                            <Dropdown.Item key={agent.id} eventKey={agent.id}>{agent.name}</Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown> */}
                      <Dropdown id='cl_dd_filter' className="cl_dd" onSelect={filterSelect}>
                        <Dropdown.Toggle variant="warning">
                        Explore by Age: {selectedFilter}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filterLoading && <Dropdown.Item>Loading...</Dropdown.Item>}
                          {filterError && <Dropdown.Item>Error: {filterError.message}</Dropdown.Item>}
                          {!filterLoading && !filterError && filters.map((filter) => (
                            <Dropdown.Item key={filter.id} eventKey={filter.id}>{filter.filter}</Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                      <Dropdown className="cl_dd" onSelect={categorySelect}>
                        <Dropdown.Toggle variant="warning">
                          Category: {selectedCategory}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {crackersCategory.map((category) => (
                            <Dropdown.Item key={category.category}>{category.category}</Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>

                    <div>
                    <table className="cl_ct_est">
                      <thead>
                        {/* <tr>
                          <td colSpan="3">
                            <span>Cart valuation from <b>{selectedAgentName}</b></span>
                          </td>
                        </tr> */}

                        <tr>
                          <th>Items count</th>
                          <th>Quantity</th>
                          <th>Cost</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{cartValuation["number_of_items"]}</td>
                          <td>{cartValuation["total_quantity"]}</td>
                          <td>{cartValuation["total_cost"]}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Col>
                <Col xs={1} sm={1} md={1}></Col>
              </Row>
              {crackerLoading ? (
                <PageLoader/>
              ) : (
                filteredCrackers && Object.keys(filteredCrackers).length > 0 ? (
                    <BuildCrackersList
                      crackersList = {crackersData}
                      filteredCrackers={filteredCrackers}
                      activePage={activePage}
                      selectedCategory={selectedCategory}
                      selectedFilter={selectedFilter}
                      selectedCart={selectedCart}
                      cartItems={cartItems}
                      cartImageChecker={cartImageChecker}
                      cartImageRef={cartImageRef}
                      agentCode={agentCode}
                      setLandingPage={setLandingPage}
                      serviceCommonData={serviceCommonData}
                      setCartItems={setCartItems}
                      setCartValuation={setCartValuation}
                      handlePageChange={handlePageChange}
                      agentNotFound={agentNotFound}
                    />
                ) : (
                  agentNotFound ? (<DealerNotFound />) : (<CrackersNotFound />)
                )
              )}

            </div>
        )
      }
    </div>
  );
}

function MobileCrackersTile ({filteredCrackers, crackersList, selectedCategory, selectedCart, cartItems, cartImageChecker, cartImageRef, setLandingPage, serviceCommonData, setCartItems, setCartValuation, rType}) {
  
  var categoriesType = [];
  var crackerByCategory = {};

  const {setShowErrorToastStatus, setToastBody, userInfo, browserCart} = useContext(CrackersContext);

  const [currentCategory, setCurrentCategory] = useState(0);
  const [categories, setCategories] = useState([]);
  const [crackersByCategory, setCrackersByCategory] = useState({});
  const [categoriesIndex, setCategoriesIndex] = useState({});
  const [crackers, setCrackers] = useState({});
  const [hasTop, setHasTop] = useState(false);
  const [hasRight, setHasRight] = useState(true);
  const [hasBottom, setHasBottom] = useState(true);
  const [hasLeft, setHasLeft] = useState(false);
  const [direction, setDirection] = useState("none");
  const [crackersImages, setCrackersImages] = useState([]);
  const [crackersDescription, setCrackersDescription] = useState("");
  const [showDescription, setShowDescription] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const leftMostDot = useRef(null);
  const leftDot = useRef(null);
  const rightDot = useRef(null);
  const rightMostDot = useRef(null);
  const imageComp = useRef(null);
  // const intervalRef = useRef(null);
  const [runTour, setRunTour] = useState(false); 
  const tourSteps = [
    {
      target: '.step1',
      content: 'Crackers are grouped by age suitability, making it easy to find the right ones for kids, teens, or adults.',
    },
    {
      target: '.step2',
      content: 'Choose crackers based on when you want to use them — perfect for selecting daytime or nighttime fireworks.',
    },
    {
      target: '.step3',
      content: 'Explore crackers by type - sparklers, garlands, flowerpots, and more, all neatly organized for you.',
    },
    {
      target: '.step4',
      content: 'Swipe left or right to explore crackers within the same type, or swipe up and down to move to the next or previous type.',
    },
    {
      target: '.step5',
      content: 'Tap here to see a detailed popup with the description, pricing, and effects of the selected cracker.      ',
    },
    {
      target: '.step6',
      content: 'These dots indicate your position in the list — swipe left or right to move between crackers in the same category.',
    },
  ];

  const cdTnClick = (event) => {
    const currentSrc = event.currentTarget.src;
    imageComp.current.src = currentSrc;
    // if (intervalRef.current) {
    //   clearInterval(intervalRef.current);
    // }
}

  const mobileCrackersData = () => {
    if(filteredCrackers && Object.keys(filteredCrackers).length > 0) {
      for(let i=1; i<=Object.keys(filteredCrackers).length; i++) {
        if(filteredCrackers.hasOwnProperty(i + "")) {
          var crackersPage = filteredCrackers[i + ""];
          for(let j=0; j<crackersPage.length; j++) {
            let crackers = [];
            var type = crackersPage[j]["type"];
            if (selectedCategory === 'All') {
              crackers = crackersPage[j]["crackers"];
            } else {
              for(let k=0; k<crackersPage[j]["crackers"].length; k++) {
                if(crackersPage[j]["crackers"][k].category === selectedCategory) {
                  crackers.push(crackersPage[j]["crackers"][k]);
                }
                
              }
            }
            
            if(crackers.length > 0) {
              if(categoriesType.includes(type)) {
                crackerByCategory[type] = crackerByCategory[type].concat(crackers);
              } else {
                categoriesType.push(type);
                crackerByCategory[type] = [];
                crackerByCategory[type] = crackers;
              }
            }
          }
        }
      }
    }
  }

  const mobCatChange = (eventKey, event) => {
    const option = event.target.textContent;
    let categoryIndex = categories.indexOf(option)
    let crackersIndex = categoriesIndex[option];
    changeCrackers(option, crackersByCategory, categoryIndex, crackersIndex, categories);
    
  }

  const changeCrackers = (option, crackersByCategory, categoryIndex, crackersIndex, categories) => { 
    var choosenCrackers = crackersByCategory[option][crackersIndex];
    setCurrentCategory(categoryIndex);
    if(crackers["id"] !== choosenCrackers["id"]) {
      setCrackers(choosenCrackers);
      getCrackersImages(choosenCrackers.id);
      screenNavigator(crackersIndex, categoryIndex, crackersByCategory, categories);
    }
  }

  const getCrackersImages = async (crackersId) => {
    if(imageComp === null) {
      return;
    }
    // if (intervalRef.current) {
    //   clearInterval(intervalRef.current);
    // }
    const crackersDetails = await getCracker(userInfo, crackersId, selectedCart, null, setShowErrorToastStatus, setToastBody, browserCart);
    var crackersImageArray = crackersDetails.images;
    setCrackersImages(crackersDetails.images);
    setCrackersDescription(crackersDetails.description);

    // if(crackersImageArray.length > 1) {
    //   if (intervalRef.current) {
    //     clearInterval(intervalRef.current);
    //   }
    //   let currentImageIndex = 1;
    //   intervalRef.current = setInterval(() => {
    //     imageComp.current.src =crackersImageArray[currentImageIndex];
    //     currentImageIndex = (currentImageIndex + 1) % crackersImageArray.length;
    //   }, 5000);
    // }
  }

  useEffect(() => {
    mobileCrackersData();
    setCategories(categoriesType);
    setCrackersByCategory(crackerByCategory);
    var index = {};
    for(let i=0; i<categoriesType.length; i++) {
      index[categoriesType[i]] = 0;
    }

    if(rType && rType !== undefined && Object.keys(crackerByCategory).length > 0) {
      setCurrentCategory(categoriesType.indexOf(rType));
      changeCrackers(rType, crackerByCategory, categoriesType.indexOf(rType), 0, categoriesType);
    } else {
      if(categoriesType.length > 0) {
        let crackers = crackerByCategory[categoriesType[0]][0];
        getCrackersImages(crackers.id);
        setCrackers(crackers);
        setCrackersByCategory(crackerByCategory);
        screenNavigator(0, 0, crackerByCategory, categoriesType);
      }  
    }
    setCategoriesIndex(index);

    const hasSeenTour = localStorage.getItem("mobCrClTour");
    if (hasSeenTour !== "true") {
      setRunTour(true);
    } else {
      setRunTour(false);
      // localStorage.setItem("mobCrClTour", "false");
    }
    // window.scrollTo(0, 0);
    // alert("done");
    return () => {
      // if (intervalRef.current) {
      //   clearInterval(intervalRef.current);
      // }
    };
    
  }, [filteredCrackers]);

  const showCrDescription = () => {
    setShowDescription(true);
  };

  const screenNavigator = (crackersIndex, currentCategory, crackersByCategory, categories) => {
    var rightItems = (crackersByCategory[categories[currentCategory]].length - crackersIndex) - 1;
    if(rightItems <= 1) {
      if(rightItems === 1) {
        rightMostDot.current.style.visibility = 'hidden';
        rightDot.current.style.visibility = 'visible';
      } else {
        rightMostDot.current.style.visibility = 'hidden';
        rightDot.current.style.visibility = 'hidden';
      }
    } else {
      rightMostDot.current.style.visibility = 'visible';
      rightDot.current.style.visibility = 'visible';
    }

    if(crackersIndex < 2) {
      if(crackersIndex === 1) {
        leftMostDot.current.style.visibility = 'hidden';
        leftDot.current.style.visibility = 'visible';
      } else {
        leftMostDot.current.style.visibility = 'hidden';
        leftDot.current.style.visibility = 'hidden';
      }
    } else {
      leftMostDot.current.style.visibility = 'visible';
      leftDot.current.style.visibility = 'visible';
    }

    if (crackersByCategory[categories[currentCategory]].length > 1) {
      if(crackersIndex >= crackersByCategory[categories[currentCategory]].length - 1) {
        setHasLeft(true);
        setHasRight(false);
        return;
      } else if(crackersIndex <= 0) {
        setHasLeft(false);
        setHasRight(true);
      } else {
        setHasLeft(true);
        setHasRight(true);
      }
    } else {
      setHasLeft(false);
      setHasRight(false);
    }

    if(categories.length > 1) {
      if(currentCategory <= 0) {
        setHasTop(false);
        setHasBottom(true);  
      } else if(currentCategory >= categories.length - 1) {
        setHasTop(true);
        setHasBottom(false);
      } else {
        setHasTop(true);
        setHasBottom(true);
      }
    } else {
      setHasTop(false);
      setHasBottom(false);
    }
  }

  const handlers = useSwipeable({
    onSwipedLeft: () => {
                          setDirection("left");
                          let indices = categoriesIndex;
                          var nextIndex = indices[categories[currentCategory]] + 1;
                          if(nextIndex >= crackersByCategory[categories[currentCategory]].length) {
                            nextIndex = crackersByCategory[categories[currentCategory]].length - 1;
                          } 
                          indices[categories[currentCategory]] = nextIndex;
                          setCategoriesIndex(indices);
                          var choosenCrackers = crackersByCategory[categories[currentCategory]][nextIndex];
                          if(crackers["id"] !== choosenCrackers["id"]) {
                            setCrackers(choosenCrackers);
                            getCrackersImages(choosenCrackers.id);
                            screenNavigator(nextIndex, currentCategory, crackersByCategory, categories);
                          }
                        },
    onSwipedRight: async () => {
                            setDirection("right");
                            let indices = categoriesIndex;
                            var nextIndex = indices[categories[currentCategory]] - 1;
                            if(nextIndex <= 0) {
                              nextIndex = 0;
                            }
                            indices[categories[currentCategory]] = nextIndex;
                            setCategoriesIndex(indices);
                            var choosenCrackers = crackersByCategory[categories[currentCategory]][nextIndex];
                            if(crackers["id"] !== choosenCrackers["id"]) {
                              setCrackers(choosenCrackers);
                              getCrackersImages(choosenCrackers.id);
                              screenNavigator(nextIndex, currentCategory, crackersByCategory, categories);
                            }
                          },
    onSwipedUp: async () => {
                        setDirection("up");
                        let nextIndex = currentCategory + 1;
                        if(nextIndex >= categories.length) {
                          nextIndex = categories.length - 1;
                        }
                        setCurrentCategory(nextIndex);
                        var choosenCrackers = crackersByCategory[categories[nextIndex]][categoriesIndex[categories[nextIndex]]];
                        if(crackers["id"] !== choosenCrackers["id"]) {
                          setCrackers(choosenCrackers);
                          getCrackersImages(choosenCrackers.id);
                          screenNavigator(categoriesIndex[categories[nextIndex]], nextIndex, crackersByCategory, categories);
                        }
                      },
    onSwipedDown: async (e) => {
                      setDirection("down");
                      let nextIndex = currentCategory - 1;
                      if(nextIndex < 0) {
                        nextIndex = 0;
                      }
                      setCurrentCategory(nextIndex);
                      var choosenCrackers = crackersByCategory[categories[nextIndex]][categoriesIndex[categories[nextIndex]]];
                      if(crackers["id"] !== choosenCrackers["id"]) {
                        setCrackers(choosenCrackers);
                        getCrackersImages(choosenCrackers.id);
                        screenNavigator(categoriesIndex[categories[nextIndex]], nextIndex, crackersByCategory, categories);
                      }
                    },
    preventDefaultTouchmoveEvent: true,
    trackTouch: true,
    trackMouse: true 
  });

  const mobCrClTourCallback = (e) => {
    var action = e.action;
    var status = e.status;
    if(action === "skip") {
      localStorage.setItem("mobCrClTour", "true");
    }
    if(status === 'finished' || status === "ready") {
      localStorage.setItem("mobCrClTour", "true");
    }
  }

  return(
    <div className="mob-app-view" style={{height : "50vh"}}>
      <Joyride styles={{options: {zIndex: 10000,}}} steps={tourSteps} 
            run={runTour}
            continuous
            scrollToFirstStep
            showProgress
            showSkipButton
            callback={mobCrClTourCallback}
            />
      <div>
        <Row className="mob_cl_cat_title">
            
          <Dropdown className="mob_cl_dd step3" onSelect={mobCatChange}>
            <Dropdown.Toggle className="mob-cl-dd-toggle" as="div" role="button" aria-haspopup="true" aria-expanded="false" style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
              <div className="mob-cat-title" style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                <h3 className="category_title">{categories[currentCategory]}</h3> 
                <img className="mob-cat-tl-img" src={updown}/>
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu className="mob-cat-menu">
                {categories.map((category, index) => (
                    <Dropdown.Item key={category + "_" + index} eventKey={index} active={currentCategory === categories.indexOf(category)}>{category}</Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
        </Row>

        <Row>
          <Col xs={1}>
          </Col>
          <Col>
            <div className="step4" style={{ filter: crackers.stock_status === 0 ? "grayscale(100%)" : "" }}>
                <div {...handlers} className="mob-cr-tile">
                  <div>
                    <div className="cl_tile_cart">
                      <img key={crackers.id} ref={imageComp} className={`mob_cl_cr_img`} src={crackers['image_link']} alt="NA"/>
                    </div>
                    <div className="mob_cd_tn_container">
                      {crackersImages.map((imgLink, index) => {
                          return (
                            <img key={"mob_cl_img_tb" + index} className='mob_cd_tn' src={`${imgLink}`} alt={`NA`} onClick={cdTnClick}/>
                          );
                      })}
                    </div>
                    <div className="cl_tile_cart">
                    <p className="cl_title step5" style={{color : "#000000", textDecoration : "underline", color : "#0000FF"}} onClick={showCrDescription}>{crackers["name"]}</p>
                      <span>MRP ₹ <span>{crackers["mrp"]}</span></span>
                      <span>Selling Price ₹ <span>₹ {crackers["selling_price"]}</span></span>
                      <span className="cl-pr-tg" style={{color : "white", background: "#4CAF50", borderRadius : "2px"}}>Our Price ₹ {crackers["offer_price"]}</span>
                      {/* <span className="cl_count">5pcs/pkt</span> */}
                      <CartInput key={crackers.id} 
                                crackersList = {crackersList}
                                selectedCart={selectedCart}
                                crackers={crackers}
                                cartItems={cartItems}
                                cartImageChecker={cartImageChecker}
                                cartImageRef={cartImageRef}
                                setLandingPage={setLandingPage}
                                serviceCommonData={serviceCommonData}
                                setCartItems={setCartItems}
                                setCartValuation={setCartValuation}/>
                      <DescriptionPopUp show={showDescription}
                                title={crackers.name}
                                message={crackersDescription}
                                handleClose={setShowDescription} />
                    </div>
                  </div>
                </div>
              </div>

            </Col>
            <Col xs={1}>
          </Col>
        </Row>

        <Row>
          <Col xs={1}>
          </Col>
          <Col className="d-flex justify-content-center align-items-center">
            <div className="dot-container step6">
              <span className="dot dot_second_left" ref={leftMostDot}>{categoriesIndex[categories[currentCategory]] - 1}</span>
              <span className="dot dot_first_right mob-crackers-index" ref={leftDot}>{categoriesIndex[categories[currentCategory]]}</span>
              <span className="dot dot-index mob-crackers-index">{categoriesIndex[categories[currentCategory]] + 1}</span>
              <span className="dot dot_first_left mob-crackers-index" ref={rightDot}>{categoriesIndex[categories[currentCategory]] + 2}</span>
              <span className="dot dot_second_right" ref={rightMostDot}>{categoriesIndex[categories[currentCategory]] + 3}</span>
            </div>
          </Col>
          <Col xs={1}>
          </Col>
        </Row>
      </div>
    </div>
  )
}

function BuildCrackersList ({crackersList, filteredCrackers, activePage, selectedCategory, selectedFilter, selectedCart, cartItems, cartImageChecker, cartImageRef, agentCode, setLandingPage, serviceCommonData, setCartItems, setCartValuation, handlePageChange, agentNotFound }) {
  return(
    <>
      {agentNotFound ? (
        <DealerNotFound/>
      ): (
        <div className="cl_container">
          {
            <>
              <Row>
                <CrackersListPage
                  crackersList = {crackersList}
                  crackerPage={filteredCrackers[activePage]}
                  category={selectedCategory}
                  selectedFilter={selectedFilter}
                  selectedCart={selectedCart}
                  cartItems={cartItems}
                  cartImageChecker={cartImageChecker}
                  cartImageRef={cartImageRef}
                  agentCode={agentCode}
                  setLandingPage={setLandingPage}
                  serviceCommonData={serviceCommonData}
                  setCartItems={setCartItems}
                  setCartValuation={setCartValuation} />
              </Row>
              <Row className="pagination">
                <BuildPagination
                  numberOfPages={filteredCrackers["number_of_page"]}
                  methodToTrackActive={handlePageChange}
                  activePage={Number(activePage)}
                />
              </Row>
          </>
          }
        </div>
      )}
      
    </>
  );
}

function DealerNotFound() {
  console.log("Dealer not found");
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
      setIsSmallScreen((isXSmScreen(window.innerWidth) || isSmScreen(window.innerWidth)) ? true : false);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const centerOfScrn = {
    position: "absolute",
    top: isSmallScreen ? "70%" : "50%",
    left: "50%",
    transform: "translate(-50%, -50%) translate3d(0,0,0)",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }
  return(
    <>
      <div style={centerOfScrn}>
        <div>
          <h1>The dealer name is not found in our service.</h1>
          <h3>Please select a different dealer from our service.</h3>
        </div>
        {/* <div>
          <img src={agntNF}></img>
        </div> */}
      </div>
    </>
  )
}

function CrackersNotFound() {
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
      setIsSmallScreen((isXSmScreen(window.innerWidth) || isSmScreen(window.innerWidth)) ? true : false);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const centerOfScrn = {
    position: "absolute", 
    top: isSmallScreen ? "70%" : "50%",
    left: "50%",
    transform: "translate(-50%, -50%) translate3d(0,0,0)",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }

  return (
    <>
      <div style={centerOfScrn}>
        <div>
          <h2>The dealer has not yet added their list of crackers with us.</h2>
          <h5>Please try again later for updated information. Feel free to browse other dealers on our platform.</h5>
        </div>
        {/* <div>
          <img src={agntNF}></img>
        </div> */}
      </div>
    </>
  );
}

function CrackersListPage({ crackersList, crackerPage, category, selectedFilter, selectedCart, cartItems, cartImageChecker, cartImageRef, agentCode, setLandingPage, serviceCommonData, setCartItems, setCartValuation }) {
  var categoryToIterate = [];
  crackerPage.map((crackerCategory) => {
    crackerCategory["crackers"].map((cracker) => {
      if (!categoryToIterate.includes(crackerCategory["type"])) {
        if (category === 'All') {
          categoryToIterate.push(crackerCategory["type"]);
        } else if (cracker["category"] === category) {
          categoryToIterate.push(crackerCategory["type"]);
        }
      }
    });
  });

  const emptyCategory = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  };

  return (
    <div>
      {crackerPage.map((crackerCategory, index) => {
        if (categoryToIterate.includes(crackerCategory["type"])) {
          return (
            <div key={"clp_" + crackerCategory["type"] + "_" + index} >
              <div>
                <Row className="cl_cat_title">
                  <CrackersCategoryTitle title={crackerCategory["type"]} />
                </Row>
                <Row>
                  {crackerCategory["crackers"].map((crackers) => {
                    return (
                      <Col xs={6} md={4} lg={3} key={crackers.id}>
                        <CrackersTile 
                                  crackersList = {crackersList}
                                  crackers={crackers}
                                  selectedFilter={selectedFilter}
                                  selectedCart={selectedCart}
                                  cartItems={cartItems}
                                  cartImageChecker={cartImageChecker}
                                  cartImageRef={cartImageRef}
                                  agentCode={agentCode}
                                  setLandingPage={setLandingPage}
                                  serviceCommonData={serviceCommonData}
                                  setCartItems={setCartItems}
                                  setCartValuation={setCartValuation}
                                  rType={crackerCategory["type"]} />
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </div>
          );
        } else {
          return (null);
        }
      })}
    </div>
  );
}

function CrackersCategoryTitle({ title }) {
  return (
    <h3 id={"cl_" + title.replace(/ /g, "_")} className="category_title">{title}</h3>
  );
}

function CrackersTile({ crackersList, crackers, selectedFilter, selectedCart, cartItems, cartImageChecker, cartImageRef, agentCode, setLandingPage, serviceCommonData, setCartItems, setCartValuation, rType }) {
  const [clHover, setClHover] = useState(false);

  const handleMouseOver = () => setClHover(true);
  const handleMouseOut = () => setClHover(false);

  const crackerTileStyle = {
    borderRadius: '10px',
    padding: '5px',
    marginBottom: '20px',
    // border: clHover ? 'skyblue 1px solid' : 'blue 1px solid',
    backgroundColor: clHover ? 'transparent' : '#eee'
  };

  const linkToDetailView = selectedCart ? `/web/crackers/${crackers.id}?filter=${selectedFilter}&agent_id=${agentCode}&clType=${rType}&cart=${selectedCart}` :  `/web/crackers/${crackers.id}?filter=${selectedFilter}&agent_id=${agentCode}&clType=${rType}`;

  return (
    (crackers.stock_status === 0) ? (
      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Out of Stock</Tooltip>}>
        <div style={{ filter: "grayscale(100%)" }}>
          <Link to={linkToDetailView}>
            <div className="cl_tile_cart">
            <img className="cl_cr_img" src={crackers['image_link']} alt={crackers["name"]}></img>
              <span className="cl_title" style={{color : "#000000"}}>{crackers["name"]}</span>
            </div>
          </Link>
          <div className="cl_tile_cart">
            <span>MRP ₹ <span>{crackers["mrp"]}</span></span>
            <span>Selling Price ₹ <span>₹ {crackers["selling_price"]}</span></span>
            <span className="cl-pr-tg" style={{color : "white", background: "#4CAF50", borderRadius : "2px"}}>Our Price ₹ {crackers["offer_price"]}</span>
            {/* <span className="cl_count">5pcs/pkt</span> */}
            <CartInput selectedCart={selectedCart}
              crackers={crackers}
              cartItems={cartItems}
              cartImageChecker={cartImageChecker}
              cartImageRef={cartImageRef}
              setLandingPage={setLandingPage}
              serviceCommonData={serviceCommonData}
              setCartItems={setCartItems}
              setCartValuation={setCartValuation} />
          </div>
        </div>
      </OverlayTrigger>
      
    ) : (
        <div style={crackerTileStyle} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
          <Link to={linkToDetailView}>
            <div className="cl_tile_cart">
              <img className="cl_cr_img" src={crackers['image_link']} alt={crackers["name"]}></img>
              <span className="cl_title" style={{color : "#000000"}}>{crackers["name"]}</span>
            </div>
          </Link>
          <div className="cl_tile_cart">
            <span>MRP ₹ <span>{crackers["mrp"]}</span></span>
            <span>Selling Price ₹ <span>₹ {crackers["selling_price"]}</span></span>
            <span className="cl-pr-tg" style={{color : "white", background: "#4CAF50", borderRadius : "2px"}}>Our Price ₹ {crackers["offer_price"]}</span>
            {/* <span className="cl_count">5pcs/pkt</span> */}
            <CartInput 
                      crackersList = {crackersList}
                      selectedCart={selectedCart}
                      crackers={crackers}
                      cartItems={cartItems}
                      cartImageChecker={cartImageChecker}
                      cartImageRef={cartImageRef}
                      setLandingPage={setLandingPage}
                      serviceCommonData={serviceCommonData}
                      setCartItems={setCartItems}
                      setCartValuation={setCartValuation}/>
          </div>
        </div>
    )
    
  );
}

function CartInput({ crackersList, selectedCart, crackers, cartItems, cartImageChecker, cartImageRef, setLandingPage, serviceCommonData, setCartItems, setCartValuation }) {
  const quantityRef = useRef(null);
  const { setShowErrorToastStatus, setToastBody, userInfo, browserCart, setBrowserCart } = useContext(CrackersContext);
  // const [btnCaption, setBtnCaption] = useState('Add to Cart');
  const [loading, setLoading] = useState(false);
  const [qty, setQty] = useState(0);
  const [prevQty, setPrevQty] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const location = useLocation();

  function getCurrentPath() {
        const queryParams = queryString(new URLSearchParams(location.search));
        if (queryParams && queryParams.trim() !=='') {
            return location.pathname + "?" + queryParams;
        } else {
            return location.pathname;
        }
    }

  useEffect(() => {
    const cartQuantity = cartItems[crackers.id] && cartItems[crackers.id].quantity !== 0 ? cartItems[crackers.id].quantity : 0;
    if (quantityRef.current) {
      quantityRef.current.value = cartQuantity;
    }
    setQty(cartQuantity);
    setPrevQty(cartQuantity);
    // setBtnCaption(cartQuantity > 0 ? 'In the Cart' : 'Add to Cart');
  }, [cartItems]);

  const addToCart = async () => {
    if (selectedCart && selectedCart.trim() !== '') {
        const quantity = Number(quantityRef.current.value);
        const params = {
          "cart_name": selectedCart,
          "quantity": quantity
        }
        const response = await addCrackersIntoCart(userInfo, crackers.id, params, setLoading, setShowErrorToastStatus, setToastBody, browserCart, setBrowserCart);
        if (quantity !== 0) {
          cartImageRef.current.src = '/client/images/f_cart.png';
          // setBtnCaption("In the Cart");
          let price = await costOfCracker(crackersList, crackers.id);
          if (cartItems && Object.keys(cartItems).length > 0) {
            if (cartItems[crackers.id]) {
              cartItems[crackers.id]["quantity"] = quantity;
              cartItems[crackers.id]["total_cost"] = quantity * price;
            } else {
              cartItems[crackers.id] = crackers;
              cartItems[crackers.id]["quantity"] = quantity;
              cartItems[crackers.id]["total_cost"] = quantity * price;
            }
          } else {
            cartItems[crackers.id] = crackers;
            cartItems[crackers.id]["quantity"] = quantity;
            cartItems[crackers.id]["total_cost"] = quantity * price;
          }
        } else {
          cartImageChecker(selectedCart);
          // setBtnCaption("Add to Cart");
          if (cartItems && Object.keys(cartItems).length > 0 && cartItems[crackers.id]) {
            delete cartItems[crackers.id];
          }
        }
        const cartValue = {};
        if (cartItems && Object.keys(cartItems).length > 0) {
          cartValue["number_of_items"] = 0;
          cartValue["total_quantity"] = 0;
          cartValue["total_cost"] = 0;
          // var cartItemsObj = {};
          for (let item in cartItems) {
            cartValue["number_of_items"] += 1;
            cartValue["total_quantity"] += Number(cartItems[item].quantity);
            cartValue["total_cost"] += Number(cartItems[item].total_cost);
            // if (cartItems[item].stock_status !== 0) {
              
            // }

          }
          cartImageRef.current.src = "/client/images/f_cart.png";
        } else {
          cartValue["number_of_items"] = 0;
          cartValue["total_quantity"] = 0;
          cartValue["total_cost"] = 0;
          cartImageRef.current.src = "/client/images/cart.png";
        }
        setCartValuation(cartValue);
        setQty(quantity);
        setPrevQty(quantity);
    } else {
      setLandingPage("/web/crackers");
      navigate(serviceCommonData["link_signin"] ? serviceCommonData["link_signin"] : '/web/signin');
    }
  }

  const decrQuantity = () => {
    if(crackers.stock_status !== 0) {
      let quantity = Number(quantityRef.current.value);
      if (quantity > 0) {
        quantity -= 1;
        quantityRef.current.value = quantity;
      }
      setQty(quantity);
      if (prevQty !== 0 && quantity === prevQty) {
        debounceUpdateCart(-1, 500);
      } else {
        debounceUpdateCart(quantity, 500);
      }
    } else {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 2000);
    }
    
  }

  const incrQuantity = () => {
    if(crackers.stock_status !== 0) {
      let quantity = Number(quantityRef.current.value);
      quantity += 1;
      quantityRef.current.value = quantity;
      setQty(quantity);
      if (quantity === prevQty) {
        debounceUpdateCart(-1, 500);
      } else {
        debounceUpdateCart(quantity, 500);
      }
    } else {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 2000);
    }
    
  }

  const debounceUpdateCart = (qty, waitTime) => {
    if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
    }
    setLoading(true);
    timeoutRef.current = setTimeout(() => {
        if(qty !== -1 && qty !== prevQty) {
          addToCart();
        }
        setLoading(false);    
    }, waitTime);
  };

  return (
    (crackers.stock_status === 0) ? (
      <>
        <div className="cl_ct">
          <img className="cl_ct_qc" src={decr} onClick={decrQuantity} alt="Decrease Quantity" />
          <Form.Control className="cl_cart_qnt" size="sm" type="text" ref={quantityRef} value={qty} readOnly={true}/>
          <img className="cl_ct_qc" src={incr} onClick={incrQuantity} alt="Increase Quantity" />
          <Overlay target={quantityRef.current} show={showTooltip} placement="top">
            {(props) => (
              <Tooltip id="out-of-stock-tooltip" {...props}>
                Out of stock!
              </Tooltip>
            )}
          </Overlay>
        </div>
        {/* <Button className="cl_ct_btn" disabled={true}>{btnCaption}</Button> */}
      </>
    ) : (
      <>
        <div className="cl_ct">
          <img className="cl_ct_qc" style={{ cursor : "pointer"}} src={decr} onClick={decrQuantity} alt="Decrease Quantity" />
          <Form.Control className="cl_cart_qnt" size="sm" type="text" ref={quantityRef} value={qty} onChange={(e) => setQty(e.target.value)} onKeyDown={(e) => {numericInputOnly(e)}} onBlur={(e) => {addToCart()}}/>
          <img className="cl_ct_qc" style={{ cursor : "pointer"}} src={incr} onClick={incrQuantity} alt="Increase Quantity" />
        </div>
        {/* <Button className="cl_ct_btn" onClick={addToCart} disabled={(prevQty !== 0 && prevQty === qty) || (qty === 0 && prevQty === 0)}>
            {!loading && btnCaption}
            {loading && <LoadingBorder/>}
        </Button> */}
      </>
    )
    
  );
}

export default Crackers;
